const namespaced = true;

const defaultState = () => {
  return {
    packages: [],
    loading: true,
    payment:'Monthly'
  };
}

const state = defaultState();
const actions = {};
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_PACKAGES(state, packages) {
    state.packages = packages;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_PAYMENT_TYPE(state,payment){
    state.payment = payment;
  }
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
